import styled from 'styled-components';
import { Translate } from 'react-redux-i18n';

import { getEditorScrollStyles } from '../../../../styles';
import { StyleColor } from '../../../../../../utils/styles-constants';
import { hexToRgba } from '../../../../../../utils/style';

const Label = styled(Translate)`
	display: block;
	margin-top: 20px;
	font-family: HelveticaNeue, sans-serif;
	font-size: 12px;
	line-height: 20px;
	color: ${hexToRgba(StyleColor.White, 75)};
`;

const TextArea = styled('textarea')`
	box-sizing: border-box;
	width: 100%;
	height: 100px;
	padding: 10px;
	resize: none;
	outline: 0;
	border-radius: 6px;
	border: 1px solid transparent;
	background-color: ${hexToRgba(StyleColor.White, 10)};
	font-family: HelveticaNeue, sans-serif;
	color: ${StyleColor.White};

	&:hover,
	&:focus {
		border-color: ${StyleColor.White};
	}

	${getEditorScrollStyles({ width: 4 })}
`;

export {
	Label,
	TextArea,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/SliderManager/Slide/TextEditor/styles.ts